// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"346":"stores","818":"auth"}[chunkId] + "." + {"346":"919f4c10","818":"66addf4f"}[chunkId] + ".css";
};